import GlobalStyle from "./components/GlobalStyle";
// components
import Nav from "./components/Nav";
//pages
import AboutUS from "./pages/AboutUS";
import Programs from "./pages/Programs";
import ContactUS from "./pages/ContactUS";
import ProgramDetails from "./pages/ProgramDetails";
//router
import { Switch, Route, useLocation } from "react-router-dom";

//framer-motion
import { AnimatePresence } from "framer-motion";

function App() {
	const location = useLocation();
	return (
		<div className="App">
			<GlobalStyle />
			<Nav />
		<AnimatePresence exitBeforeEnter>
      <Switch location={location} key={location.pathname}>
      <Route path="/" exact>
			<AboutUS />
      </Route>
      <Route path="/programs" exact>
			<Programs/>
      </Route>
	  <Route path="/programs/:id">
		  <ProgramDetails/>
	  </Route>
      <Route path="/contact">
			<ContactUS />
      </Route>
      </Switch>
	  </AnimatePresence>
		</div>
	);
}

export default App;
